"use strict";

import {
  addFormControlSelect2,
  handleFormErrorServerSide,
  padLeft,
} from "../jquery-functions-library";
import {
  element_exists,
  isError,
  isSuccess,
  validateOnChange,
  validateRequiredWith,
} from "../functions";
import AutoNumeric from "autonumeric";
import * as toastr from "toastr";
import { options } from "toastr";

var Inputmask = require("inputmask");

/**
 * @author Batch Themes Ltd.
 * @description We use the approve.js library for form field validation. For additional information and demos go to the following urls:
 * https://github.com/CharlGottschalk/approvejs
 * http://charlgottschalk.co.za/projects/approvejs/demo
 */
export var fnCustomerEmployeesStepsValidation = function() {
  var formParentDiv = "#form-setup-employees";
  var freeCarMonthly = '#free_car_monthly';

  if (!element_exists(formParentDiv)) {
    return false;
  }

  /**
   * Prevents scrolling on fields when using the mouse wheel. Must be called on each field that needs this functionality before the AutoNumeric object is created.
   */
  initPreventScrollingOnFields();

  const salaryAN = new AutoNumeric(
    document.getElementById("salary"),
    "commaDecimalCharDotSeparator"
  );
 
  function resetActive() {
    $(".nav-link").removeClass("active");
  }

  var lang = allLangFiles.employee.validation;

  initValidation(lang);

  var isUpdateEmployee = $("#btn-quick-submit").is(":visible");

  $(formParentDiv)
    .find(":input.form-control")
    .each(function() {
      if (isUpdateEmployee) {
        $(this).focus().blur();
      } else {
        if ($(this).is(":visible")) {
          $(this).attr("data-valid", false);
        }
      }
    });

  $(document)
    .off("click", ".list-group-item-error-msg")
    .on("click", ".list-group-item-error-msg", function(e) {
      const dataTab = $(this).data("tab");
      const $errorTab = $("." + dataTab);
      $errorTab.tab("show");
      $errorTab.addClass("active");
      $("#" + $(this).data("id")).focus();
    });

  var updateUrl = "/employee/update";

  $("#hourly").prop("checked")
    ? $(".employment.salaried").hide()
    : $(".employment.hourly").hide();

  $(".employment").hide();
  $("." + $('input[name="employment[employment_type]"]:checked').val()).show();

  function toggleHonorariumEmployee(employment_type) {
    if (employment_type === "CustomerBHonorariumReceiverEmployee") {
      $(".pension-tab")
        .parents(".nav-item")
        .attr("style", "display:none !important");
      $(".btn-honorarium-quick-submit").removeClass("hidden");

      $("#bank-tab")
        .find(".btn-next")
        .addClass("hidden");

      $('[name^="optional"]')
        .parents(".form-group")
        .addClass("hidden");
    } else {
      $(".pension-tab")
        .parents(".nav-item")
        .attr("style", "display: table-cell !important");
      $(".btn-honorarium-quick-submit").addClass("hidden");
      $("#bank-tab")
        .find(".btn-next")
        .removeClass("hidden");

      $('[name^="optional"]')
        .parents(".form-group")
        .removeClass("hidden");
    }
    toggleOptionalsRequired();
  }

  toggleHonorariumEmployee(
    $('input[name="employment[employment_type]"]:checked').val()
  );
  
  $("#use_iban")
    .off("click")
    .on("click", function(e) {
      setOnChangeEmployment(lang);
  });

  $('input[name="employment[danmarks_statistik]"]')
      .off("click")
      .on("click", function(e) {
        setOnChangeEmployment(lang);
      });

  $("#btn-group-employment-type .radio-inline")
    .off("change")
    .on("change", function(e) {
      var employment_type = $(this)
        .find('input[name="employment[employment_type]"]')
        .val();

      $(".employment").hide();
      $("." + employment_type).show();

      $(".employment")
        .find(".form-group")
        .removeClass("has-danger")
        .removeClass("has-success");
      $(".employment")
        .find(".form-control")
        .removeClass("form-control-danger")
        .removeClass("form-control-success");

      $(".employment")
        .find(":input.form-control")
        .not("input[name='_token']")
        .not("input[type=radio]")
        .val("");

      $(".time_days").trigger("input");
      setOnChangeEmployment(lang);

      $(".employment")
        .find(":input.form-control")
        .each(function() {
          $(this)
            .focus()
            .blur();
        });

      toggleHonorariumEmployee(employment_type);
    });

  $(".accountTypeCheckbox")
    .off("change")
    .on("change", function(e) {
      // displayAccountType(this);
    });

  if ($("#department").is("select")) {
    $("#department")
      .select2({
        width: "100%",
        height: "100%",
      })
      .addClass("form-control");
    addFormControlSelect2();
  }

  function displayAccountType(context) {
    $(".group-pension-type").hide();
    $(".group-pension-type." + $(context).val()).show();
  }

  var currentTab = null;

  $(formParentDiv)
    .find("a.nav-link,.go-back,.btn-next")
    .off("click")
    .on("click", function(e) {
      const activeTab = $(formParentDiv).find(".nav-link.active");
      const formId = activeTab.attr("data-target");
      const form = $(formId + " form");
      const fields = [];

      validateInputInForm(form, fields);

      currentTab = $(this);

      if ($(this).is($(".btn-next,.go-back"))) {
        const target = $(this).attr("data-target");

        resetActive();

        $(target).tab("show");
        $(target).addClass("active");
        return false;
      }
    });

  $(formParentDiv)
    .find("form")
    .off("submit")
    .on("submit", function(e) {
      e.preventDefault();

      var fields = [];

      var url = isUpdateEmployee ? updateUrl : "/employee/store";

      editFormBehaviour(fields, url);

      return false;
    });

  function validateInputInForm(element, fields) {
    element.find(":input.form-control").each(function() {
      if ($(this).is(":visible")) {
        console.log(element);
        let validity = checkValidity($(this));
        fields.push(validity);
      }
    });
  }

  function toggleOptionalsRequired() {
    if (
      $('input[name="employment[employment_type]"]:checked').val() !==
      "CustomerBHonorariumReceiverEmployee"
    ) {
      validateOnChange("#flex_savings", { required: true });
      validateOnChange("#days_vacation", { required: true });
    } else {
      validateOnChange("#flex_savings", {});
      validateOnChange("#days_vacation", {});
    }
  }

  function initValidation(lang) {
    validateOnChange("#first_name", {
      required: true,
    });

    validateOnChange("#last_name", {
      required: true,
    });

    validateOnChange("#cpr", {
      required: true,
      format: {
        regex: /^(?:(?:31(?:0[13578]|1[02])|(?:30|29)(?:0[13-9]|1[0-2])|(?:0[1-9]|1[0-9]|2[0-8])(?:0[1-9]|1[0-2]))[0-9]{2}-?[0-9]|290200-?[4-9]|2902(?:(?!00)[02468][048]|[13579][26])-?[0-3])[0-9]{3}|000000-?0000$/,
      },
    });

    var im = new Inputmask({ mask: "999999-9999", placeholder: "ddmmyy-xxxx" });
    im.mask($("#cpr"));

    validateOnChange("#email", {
      email: true,
      ignoreNull: true,
    });

    validateOnChange("#company_id_display", {
      required: true,
    });

    validateOnChange("#company_id", {
      numeric: true,
      required: true,
    });

    validateOnChange("#phone_private", {
      max: 12,
    });

    validateOnChange("#phone_cell", {
      max: 12,
    });

    validateOnChange("#job_title", {
      max: 50,
    });

    validateOnChange("#country_code", {});

    validateOnChange("#allocation_of_vacation_days", {});

    validateOnChange("#employment_date", {
      required: true,
      format: /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d+$/,
    });

    validateOnChange("#department", {});

    var im = new Inputmask({ mask: "99/99/9999", placeholder: "dd/mm/yyyy" });
    im.mask($("#employment_date"));

    validateOnChange("#address", {
      required: true,
    });

    validateOnChange("#address2", {}, "", lang.address);

    validateOnChange("#postal_code", {
      required: true,
    });

    validateOnChange("#city", {
      required: true,
    });

    validateOnChange("#country_code", {
      required: true,
    });

    validateOnChange("#allocation_of_vacation_days", {
      required: true,
    });

    setOnChangeEmployment(lang);

    const requiredWithLang = allLangFiles.employee.required_with;

     var hasPensionEnabled = $("#has_pension").prop("checked");
     var companyPension = $("#c_pension_company");

    if(hasPensionEnabled && companyPension != ''){
      validateRequiredWith(
        "#c_employee_contribution",
        "#c_pension_company",
        "#c_company_contribution",
        requiredWithLang.employee_contribution,
        requiredWithLang.pension_company,
        requiredWithLang.company_contribution
      );
      validateRequiredWith(
        "#c_company_contribution",
        "#c_pension_company",
        "#c_employee_contribution",
        requiredWithLang.company_contribution,
        requiredWithLang.pension_company,
        requiredWithLang.employee_contribution
      );
      validateRequiredWith(
        "#c_pension_company",
        "#c_company_contribution",
        "#c_employee_contribution",
        requiredWithLang.pension_company,
        requiredWithLang.employee_contribution,
        requiredWithLang.company_contribution
      );
    }
    $(".bank_reg").each(function() {
      var id = "#" + $(this).attr("id");
      validateOnChange(id, {
        format: /^(?:\d{4}|)$/,
      });
    });

    $(document).on("focus", ".bank_account", function(e) {
      e.preventDefault();
      //resetMessages(element);
      return false;
    });
    $(document).on("blur", ".bank_account", function(e) {
      var id = "#" + $(this).attr("id");
      if ($(this).val() !== "") {
        $(this).val(padLeft($(this).val(), 10));
      }
      e.preventDefault();
      const result = approve.value($(this).val(), {
        format: /^(?:\d{10}|)$/,
      });
      if (result.approved) {
        isSuccess(id, "");
      } else {
        isError(id, lang.bank_account);
      }
      return false;
    });

    validateOnChange("#pension_pbs", {});

    validateOnChange("#pension_debtor_group", {});

    validateOnChange("#pension_accounting_group_id", {});

    validateOnChange("#free_car_file", {});

    validateOnChange("#production_unit", { required: true });

    toggleOptionalsRequired();

    checkRequirementsPensionCompany();
  }

  function initPreventScrollingOnFields(){
    $('#flex_savings').off('wheel').on('wheel', function(e) {
      e.preventDefault();
    });

    $('#days_vacation').off('wheel').on('wheel', function(e) {
      e.preventDefault();
    });
    
    $('#bank_reg').off('wheel').on('wheel', function(e) {
      e.preventDefault();
    });
    
    $('#bank_account').off('wheel').on('wheel', function(e) {
      e.preventDefault();
    });
    
    $('#postal_code').off('wheel').on('wheel', function(e) {
      e.preventDefault();
    });
    
    $('#c_employee_contribution').off('wheel').on('wheel', function(e) {
      e.preventDefault();
    });
    
    $('#c_company_contribution').off('wheel').on('wheel', function(e) {
      e.preventDefault();
    });
    
    $('#salary').off('wheel').on('wheel', function(e) {
      e.preventDefault();
      $(this).blur();
    });
    
    $('#hourly_rate').off('wheel').on('wheel', function(e) {
      e.preventDefault();
      $(this).blur();
    });
  }

  function setOnChangeEmployment(lang) {
    var isNotHourlyEmployee = $("#salaried").prop("checked") || $("#ceo").prop("checked");
  
    validateOnChange("#weekly_working_hours", {});
    validateOnChange("#weekly_working_days", {});
    validateOnChange("#standardTimeCalc", {});

    $(".time_days")
      .off("input")
      .on("input", function(e) {
        let total = 0;
        $(".time_days").each(function() {
          let floatValue = parseFloat($(this).val());
          if (floatValue) {
            total += floatValue;
          }
        });
        $("#standardTimeCalc").val(total.toFixed(2));
      });

    validateOnChange("#salary", isNotHourlyEmployee ? { required: true } : {});

    var freeCarEnabled = $("#has_free_car").prop("checked");
    validateOnChange("#free_car_file", freeCarEnabled ? { required: true } : {});
    validateOnChange("#free_car_file_description", freeCarEnabled ? { required: true } : {});

    validateOnChange(
      "#hourly_rate",
      $("#hourly").prop("checked") ? { required: true } : {}
    );

    var lunchArrangementEnabled = $("#has_lunch_arrangement").prop("checked");
    validateOnChange("#lunch_arrangement_monthly", lunchArrangementEnabled ? { required: true } : {});

    var dstEnabled = $("#danmarks_statistik").prop("checked");
    validateOnChange("#employment_date", dstEnabled ? { required: true } : {});
    validateOnChange("#dst_time_limited_employment", dstEnabled ? { required: true } : {});
    validateOnChange("#dst_hired_terms", dstEnabled ? { required: true } : {});
    validateOnChange("#disco_codes", dstEnabled ? { required: true } : {});
    validateOnChange("#dst_job_status", dstEnabled ? { required: true } : {});
    validateOnChange("#dst_salary_form", dstEnabled ? { required: true } : {});

    var useIbanChecked = $("#use_iban").prop("checked");
    validateOnChange("#iban", useIbanChecked ? { required: true } : {});
    validateOnChange("#swift", useIbanChecked ? { required: true } : {});
    validateOnChange("#bank_reg", useIbanChecked ? { } : { required: true});
    validateOnChange("#bank_account", useIbanChecked ? {} : { required: true});
  }

  function checkValidity(element) {
    element.blur();
    return (
      element.attr("data-valid") === "true" ||
      element.attr("data-valid") === undefined
    );
  }

  function editFormBehaviour(fields, url) {
    const errorEls = [];
    $(formParentDiv + " .form-control").each(function() {
      let isValid = checkValidity($(this));
      fields.push(isValid);
      if (!isValid) {
        console.log($(this));
        errorEls.push($(this));
      }
    });

    const formData = new FormData();

    $(formParentDiv + " form").each(function() {
      salaryAN.formUnformat();
      
      if(element_exists(freeCarMonthly)){
        const freeCarMonthlyAN = new AutoNumeric(
          document.getElementById("free_car_monthly"),
          "commaDecimalCharDotSeparator"
        );
        freeCarMonthlyAN.formUnformat();
      }
      for (let i = 0; i < $(this).serializeArray().length; i++) {
        let current = $(this).serializeArray()[i];
        formData.append(current["name"], current["value"]);
      }
      
      salaryAN.formReformat();

      if(element_exists(freeCarMonthly)){
        const freeCarMonthlyAN = new AutoNumeric(
          document.getElementById("free_car_monthly"),
          "commaDecimalCharDotSeparator"
        );
        freeCarMonthlyAN.formReformat();      
      }
    });

    if(element_exists(freeCarMonthly)){
      if (document.getElementById("free_car_file").files.length > 0) {
        formData.append(
          "employment[free_car_file]",
          document.getElementById("free_car_file").files.item(0)
        );
      } else if (
        document.getElementById("free_car_file").files.length === 0 &&
        $("#free_car_file").is(":visible")
      ) {
        formData.append("employment[free_car_file]", "");
      }
    }

    if (fields.includes(false)) {
      const tabPaneId = $($(".form-control.form-control-danger")[0])
        .parents(".tab-pane")
        .attr("id");
      const errorTab = $(".nav-link." + tabPaneId);
      const $errorList = $(".list-group-error-messages");
      const $errorContainer = $(".container-error-messages");

      $errorContainer.removeClass("hidden");
      $errorList.html("");

      errorTab.tab("show");
      errorTab.addClass("active");

      for (let i = 0; i < errorEls.length; i++) {
        const parentTabId = errorEls[i].parents(".tab-pane").attr("id");
        $errorList.append(
          `<li class="list-group-item list-group-item-danger list-group-item-error-msg list-group-item_${errorEls[
            i
          ].attr("id")}" data-id="${errorEls[i].attr(
            "id"
          )}" data-tab="${parentTabId}">${errorEls[i].data("error-msg")}</li>`
        );
      }

      return false;
    }

    submitData(url, formData);
  }

  function submitData(url, formData) {
    $.ajax({
      method: "POST",
      url: url,
      data: formData,
      processData: false,
      contentType: false,
      success: function(response) {
        console.log(response);

        toastr.success(response.success);

        $.pjax({
          url: response.href,
          container: "#pjax-container",
        });
      },
      error: function(data) {
        if (data.status === 403) {
          toastr.error(allLangFiles.forms.unauthorized);
        }

        console.log(data);
        const errors = $.parseJSON(data.responseText);

        let isFirst = true;

        $.each(errors.errors, function(index, value) {
          var elementBlocks = index.split(".");
          var tabPaneId = elementBlocks[0];
          var elementName = "";

          for (var i = 0; i < elementBlocks.length; i++) {
            if (i > 0) elementName += "[" + elementBlocks[i] + "]";
            else elementName += elementBlocks[i];
          }

          resetActive();
          console.log(tabPaneId, elementName, value, isFirst);
          handleFormErrorServerSide(tabPaneId, elementName, value, isFirst);

          console.log(errors);

          isFirst = false;
        });
      },
    });
  }

  /**
   * Logic to handle toggling between IBAN and DK bank details
   */
  if ($("#use_iban").is(":checked")) {
    $(".iban_container").removeClass("hidden");
    $(".dk-bank-details").addClass("hidden");
  } else {
    $(".iban_container").addClass("hidden");
    $(".dk-bank-details").removeClass("hidden");
  }

  $("#use_iban").on("change", function() {
    if ($(this).is(":checked")) {
      $(".iban_container").removeClass("hidden");
      $(".dk-bank-details").addClass("hidden");
    } else {
      $(".iban_container").addClass("hidden");
      $(".dk-bank-details").removeClass("hidden");
    }
  });

  /**
   * Logic to handle toggling between percent/amount for company pension
   */
  $('input[type="radio"][name="companyPension[type]"]').on(
    "change",
    function() {
      let input = $(".company-pension-input");
      if (this.value == "amount") {
        let htmlWithoutPercentage = input.html().replace("%", "kr.");
        input.html(htmlWithoutPercentage);
      } else {
        let htmlWithPercentage = input.html().replace("kr.", "%");
        input.html(htmlWithPercentage);
      }
      $(".pension-information-box.company-pension").toggleClass("hidden");
    }
  );

/**
 * Check requirements for pension provided by the company.
 */
function checkRequirementsPensionCompany() {
  $('[name="companyPension[pension_company]"]').on('change', function () {
    if ($('[name="companyPension[pension_company]"]').val() == "Other" || $('[name="companyPension[pension_company]"]').val() == "Andet") {
      validateOnChange("#c_employee_contribution", { required: true });
      validateOnChange("#c_company_contribution", { required: true });
    } else {
      validateOnChange("#c_employee_contribution", {});
      validateOnChange("#c_employee_contribution", {});
    }
    validateOnChange("#c_employee_contribution", { required: true });
    validateOnChange("#c_company_contribution", { required: true });
  });
}
}